import { useEffect, useState } from 'react';

/** One entry of `public/drawings/examples/index.json`, written by `scripts/osm-drawing-example.mjs`. */
export interface DrawingExample {
  id: string;
  name: string;
  place: string;
  polygons: number;
  /** Document and preview, relative to the examples folder. */
  file: string;
  preview: string;
}

export const EXAMPLES_URL = '/drawings/examples/';

let cached: Promise<DrawingExample[]> | null = null;

/** The example drawings (fetched once per page load); `null` while loading, `'failed'` if unavailable. */
export function useDrawingExamples(): DrawingExample[] | null | 'failed' {
  const [examples, setExamples] = useState<DrawingExample[] | null | 'failed'>(null);
  useEffect(() => {
    cached ??= fetch(`${EXAMPLES_URL}index.json`).then((response) =>
      response.ok ? (response.json() as Promise<DrawingExample[]>) : Promise.reject(response.status),
    );
    let active = true;
    cached.then(
      (list) => active && setExamples(list),
      () => {
        cached = null;
        if (active) setExamples('failed');
      },
    );
    return () => {
      active = false;
    };
  }, []);
  return examples;
}
